<template>
  <div class="main-body margin_bottom" style="">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <div class="book_font_cover">
            <img :src="audiobook.thumb_path" class="img-fluid" />
          </div>
        </div>
        <div class="col-12 col-md-9">
          <h2 class="book_title">{{ audiobook.name }}</h2>
          <!-- <div class="d-flex gap-3">
            <p class="audio_rating mb-1">
              {{ audiobook.rating }}&nbsp;<i class="fa fa-star"></i>
            </p>
            <p class="audio_listener mb-1" v-if="audiobook.play_count == null">
              0&nbsp;<i class="fa fa-headphones-alt"></i>
            </p>
            <p class="audio_listener mb-1" v-else>
              {{ audiobook.play_count }}&nbsp;<i
                class="fa fa-headphones-alt"
              ></i>
            </p>
          </div> -->
          <div class="d-flex flex-column flex-md-row gap-0 gap-md-4">
            <p class="book_author mb-1">
              <strong class="me-2">Author:</strong> {{ audiobook.author_name }}
            </p>
            <p class="audio_artis mb-1">
              <strong class="me-2">Vocal Artist : </strong>
              {{ audiobook.contributing_artists }}
            </p>
          </div>
          <div class="book_short_details">{{ audiobook.description }}</div>
          <button
            class="btn btn-primary btn-sm mt-2"
            data-bs-toggle="modal"
            data-bs-target="#UpdateAudioBookModal"
          >
            Edit AudioBook
          </button>

          <hr class="bg-white mt-5" />
          <h3 class="text-white">Episodes</h3>
          <button
            class="btn btn-primary btn-sm"
            style="margin-bottom: 10px"
            data-bs-toggle="modal"
            data-bs-target="#AddNewEpisodeModal"
          >
            <i class="fa fa-plus-square fa-2x"></i>
          </button>
          <div class="music_list">
            <ul>
              <li v-for="(episode, index) in episodes" :key="index">
                <div class="d-flex gap-2 align-self-center">
                  <img :src="audiobook.thumb_path" width="70" height="70" />
                  <div>
                    <span>{{ episode.name }}</span>
                    <i
                      class="fas fa-edit"
                      style="position: absolute; right: 35px"
                      data-bs-toggle="modal"
                      data-bs-target="#UpdateEpisodeModal"
                      v-on:click="
                        updateEpisode(
                          episode.id,
                          episode.name,
                          episode.file_path
                        )
                      "
                    ></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <update-audio-book-modal
          :audioBookId="audiobook.id"
          :audioBookImage="audiobook.thumb_path"
          :audioBookName="audiobook.name"
          :audioBookEnName="audiobook.en_name"
          :audioBookAuthor="audiobook.author_name"
          :audioBookArtist="audiobook.contributing_artists"
          :audioBookPublisher_id="audiobook.publisher_id"
          :audioBookCategoryId="audiobook.category_id"
          :audioBookCategory="audiobook.c_name"
          :audioDescription="audiobook.description"
          :audioBookPrice="audiobook.price"
        ></update-audio-book-modal>
        <add-episode-modal :audioBook_id="audiobook.id" />
        <UpdateEpisodeModal
          :EpisodeId="episodeId"
          :EpisodeName="episodeName"
          :EpisodeFile="episodeFile"
        >
        </UpdateEpisodeModal>
      </div>
    </div>
    <!--  audio player-->
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
import AddEpisodeModal from "./AddEpisodeModal";
import UpdateAudioBookModal from "./UpdateAudioBookModal";
import UpdateEpisodeModal from "./UpdateEpisodeModal";
export default {
  name: "PublisherAudiobook",
  components: {
    Loading,
    UpdateAudioBookModal,
    AddEpisodeModal,
    UpdateEpisodeModal,
  },
  data() {
    return {
      audiobook: [],
      episodes: [],
      episodeId: null,
      episodeName: null,
      episodeFile: null,
      id: this.$route.params.id,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks/" + this.id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status == 200) {
          this.audiobook = res.data[0][0];
          console.log("Hello" ,this.audiobook)
          this.episodes = res.data[4];
          // console.log(this.audiobook, this.episodes);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
      this.isLoading = false;
    },
    updateEpisode(id, name, file) {
      this.episodeId = id;
      this.episodeName = name;
      this.episodeFile = file;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
@import "../../assets/css/details.scss";
</style>
